import script from "./AdminRolesView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRolesView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__